import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export interface SubmitTicketRequest {
    subject: string;
    issue: string;
    reference?: string;
}

export const callSubmitTicket = async (data: SubmitTicketRequest) => {
    try {
        const submitTicketFn = httpsCallable<SubmitTicketRequest, { success: boolean; ticketId?: string; message?: string }>(
            functions,
            'submitTicket'
        );
        const result = await submitTicketFn(data);
        return result.data;
    } catch (error: unknown) {
        throw new Error(error instanceof Error ? error.message : 'Failed to submit ticket');
    }
};
